<div class="legalLogoFloatingWrapper">
  <div class="legalLogoFloating">
    <img src="assets/logo.png" alt="brightscrip logo" />
  </div>
</div>
<div class="d-flex justify-content-center align-items-center">
  <div class="legalContentWrapper">
    <ng-content />
  </div>
</div>
